import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home.vue'
import CloudPhone from '@/views/cloudPhone/index.vue'
import mine from './mine/index.js'
import login from './login/index.js'
import home from './home/index'
import cloudPhone from './cloudPhone/index'
import Buy from './buy'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/cloudPhone',
        name: 'CloudPhone',
        component: CloudPhone
    },
    ...mine,
    ...login,
    ...home,
    ...cloudPhone,
    ...Buy,
    {
        name: '404',
        path: '/404',
        component: () => import('../views/notFound.vue')
    },
    {
        path: '*',    // 此处需特别注意至于最底部
        redirect: '/404'
    }
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

export default router
